<template>
    <FullFillBox
        :pageID="1030"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <div class="row">
            <div class="col-12" style="margin: auto;">
                <div class="row">
                    <div class="col-md-3 col-12" style="margin-top: 20px;">
                        <p>{{ $t('main_from') }} :<input type="datetime-local" id="start-time"
                                                           v-model="startDataTime"
                                                           min="2022-11-01T00:00"
                                                           @change="timeFilterChanged">
                        </p>
                    </div>
                    <div class="col-md-3 col-12" style="margin-top: 20px;">
                        <p>{{ $t('main_to') }} :<input type="datetime-local" id="end-time"
                                                         v-model="endDataTime"
                                                         min="2022-11-01T00:00"
                                                         @change="timeFilterChanged">
                        </p>
                    </div>
                    <div class="col-md-2 col-12" style="margin-top: 10px;">
                        <button class="btn btn-primary" @click="resetTimeFilter">{{ $t('common_reset') }}</button>
                    </div>
                    <div class="col-md-4 col-12" style="margin-top: 10px;">
                    </div>
                </div>
            </div>
        </div>

        <div ref="tabulatorTableUse"></div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";
export default {
    name: "SystemLogTableView",
    components: {
        FullFillBox
    },
    data() {
        return {
            permissionDetails: {},
            nowDataTime: '',
            startDataTime: '',
            endDataTime: '',
        }
    },
    methods: {
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/client/system-log/')
                .then(response => {
                    this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
                        placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                        maxHeight: '80vh',
                        responsiveLayout: 'collapse',
                        layout: "fitColumns",
                        movableColumns: true,
                        movableRows: false,
                        groupStartOpen: false,
                        data: response.data.details,
                        columns: [
                            {
                                width:200, responsive:0,
                                title: this.$t('table_create_date'),
                                field: "create_data",
                                sorter: "string",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('table_category'),
                                field: this.$store.state.language === "en" ? "en_name" : "tc_name",
                                sorter: "string",
                                headerFilter:"list",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('table_show_name'),
                                field: "show_name",
                                sorter: "string",
                                headerFilter:"list",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('sys_role'),
                                field: "roleName",
                                sorter: "string",
                                headerFilter:"list",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:2, responsive:5, minWidth: 300,
                                title: this.$t('table_details'),
                                field: this.$store.state.language === "en" ? "enDetail" : "tcDetail",
                                sorter: "string",
                                formatter: "textarea",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:0, minWidth: 50,
                                title: this.$t('table_ip'),
                                field: "user_ip",
                                sorter: "number",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                visible: false,
                                field: 'cat_id'
                            },
                        ],
                        rowFormatter: (row, e) => {
                            let cat = row.getData().cat_id
                            if (cat === 1) {
                                row.getElement().style.backgroundColor = "#ffafaf"
                            }else if (cat === 2) {
                                row.getElement().style.backgroundColor = "#dbffaf"
                            }else if (cat === 3) {
                                row.getElement().style.backgroundColor = "#aff3ff"
                            }else if (cat === 4) {
                                row.getElement().style.backgroundColor = "#faafff"
                            }
                        }
                    })
                })
            this.$store.commit('setIsTopLoading', false)
        },
        minMonths(date, months) {
            let d = date.getDate();
            date.setMonth(date.getMonth() - +months);
            if (date.getDate() !== d) {
                date.setDate(0);
            }
            return date;
        },
        setTimeFilter(){
            // History auto show pass 1-month records
            // Otherwise, data many get mass for years
            let now = new Date();
            now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
            this.endDataTime = now.toISOString().slice(0,16);
            this.nowDataTime = now.toISOString().slice(0,16);
            this.startDataTime = this.minMonths(now, 1).toISOString().slice(0,16)
        },
        async resetTimeFilter(){
            this.$store.commit('setIsTopLoading', true)
            this.setTimeFilter()
            await this.$mainApi.get(`api/client/system-log/`)
                .then(response => {
                    this.tabulator.setData(response.data.details)
                })
                .catch(errors => {
                    this.$swal.fire({
                        title: this.$t('main_page_error_licenceChecker_error_no_network'),
                        text: this.$t('main_page_error_licenceChecker_error_detail') + errors,
                        icon: 'warning',
                    })
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async timeFilterChanged(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get(`api/client/system-log/?&start=${this.startDataTime}&end=${this.endDataTime}`)
                .then(response => {
                    this.tabulator.setData(response.data.details)
                })
                .catch(errors => {
                    this.$swal.fire({
                        title: this.$t('main_page_error_licenceChecker_error_no_network'),
                        text: this.$t('main_page_error_licenceChecker_error_detail') + errors,
                        icon: 'warning',
                    })
                })
            this.$store.commit('setIsTopLoading', false)
        }
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('sys_log')
        await this.getBackendData()
        this.setTimeFilter()
    }
}
</script>

<style scoped>

</style>
